import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Text, View } from 'react-native';
import { TextInput as CropCircleTextInput } from '../../crop-circle/Components/TextInput/TextInput';
import { tokens } from '../../crop-circle/tokens';
import { DateRangeSelector, useFormContext } from '../../forms';
import { AlertInputs } from './types';
import { Colors } from '../../../themes/colors';
import { themedStyleSheet } from '../../../themes/themedStyleSheet';

export const AlertOptions = () => {
  const { t } = useTranslation();
  const { setValue, control, getValues } = useFormContext();

  const alertName = getValues(AlertInputs.alertLabel);
  const alertNamePlaceholder = getValues(AlertInputs.alertLabelPlaceholder);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t('alerts.customLabelTitle')}</Text>
      <CropCircleTextInput
        value={alertName}
        onChangeText={(text) =>
          setValue(AlertInputs.alertLabel, text, { shouldDirty: false })
        }
        placeholder={alertNamePlaceholder || t('common.optional')}
        textArea={true}
        numberOfLines={2}
        autoExpand={true}
        backgroundColor={Colors.role.surfaceHover}
        hideBorder={true}
        style={styles.textInputWrapper}
      />

      <Text style={styles.title}>{t('alerts.blackoutDates')}</Text>
      <DateRangeSelector
        control={control}
        setValue={setValue}
        maxYears={5}
        minDate={moment().format('YYYY-MM-DD')}
        styleContainer={styles.dateRangeContainer}
      />
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    minHeight: 0,
  },
  title: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    color: role.textStrong,
    marginBottom: tokens.spacing.sm,
  },
  textInputWrapper: {
    marginBottom: tokens.spacing.lg,
  },
  dateRangeContainer: {
    flexDirection: 'row',
    gap: tokens.spacing.sm,
  },
}));
